// extracted by mini-css-extract-plugin
module.exports = {"grey100":"#F2F2F7","sticky":"StickyBottom_sticky__8JJOs","transparent":"StickyBottom_transparent__dQ5A7"};